import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Bezorging',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Roomservice',
      [RoomServiceLocationType.TableService]: 'Tafelservice',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Naam deurbel (optioneel)',
    },
    company_name: {
      placeholder: 'Bedrijfsnaam (optioneel)',
    },
    customer_note: {
      placeholder: 'Bezorginstructies (optioneel)',
    },
    order_instructions: {
      placeholder: 'Voer bestelinstructies in...',
    },
  },
};
